import { render, staticRenderFns } from "./MyOrderFcl.vue?vue&type=template&id=2f72ed21&scoped=true"
import script from "./MyOrderFcl.vue?vue&type=script&lang=js"
export * from "./MyOrderFcl.vue?vue&type=script&lang=js"
import style0 from "./MyOrderFcl.vue?vue&type=style&index=0&id=2f72ed21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72ed21",
  null
  
)

export default component.exports